/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHerbalAnchorFlagViewProps } from './herbal-anchor-flag';

export default (props: IHerbalAnchorFlagViewProps) => {
    const { className, anchorTagId } = props.config;
    return <span className={className} id={anchorTagId} />;
};
